export default {
  name: 'Hoang Kim Minh',
  DOB: '3th March, 1999',
  phoneNumber: '+84344955825',
  email: 'minhhk0312.uet@gmail.com',
  address: 'Minh Hiep 1 village, Minh Khai commune, Hoai Duc district, Hanoi city',
  school:
    'Student at University of Engineering and Technology, Vietnam National University (VNU)',
  major: 'Information Technology',
  GPA: 'GPA: 3.6',
  character: 'Sociable, hardworking, studious, enthusiastic',
  hobbies: 'Interested in technology, science, film, music, cooking,...'
}
